module.exports = __webpack_public_path__ + "static/media/hra-logo.a748fa22.png";